import React, { useContext, useEffect, useRef, useState } from 'react';

//**********************Componentes PrimeReact************************************* */
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel'

//***************************Componentes Generaless***************************************** */
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import Loader from '../../../../Base/Components/Loader/Loader';
// import { getCuentasBalanceDisponibleProveedor, getComprobantesRetencionByFacturas } from '../../../../API/Compras/PagoProveedores/PagosProveedoresRequest';
import { getCuentasBalanceDisponibleProveedor } from '../../../../APIPR/CuentasPorPagar/DetalleCuentasPorPagar/DetalleCuentasPorPagarRequest'
import { getComprobantesRetencionByFacturas } from '../../../../APIPR/Retencion/ComprobanteRetencion/ComprobanteRetencionRequest';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { useForm } from '../../../../Base/Hooks/useForm';
import { formatNumberDecimal } from '../../../../Base/Services/FormatTemplate';
import { RedondearNumero } from "../../../../Base/Utils/Funciones/Funciones";
import { Toast } from 'primereact/toast';

import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';

const OverlayFacturasPendientesPorPagar = ({ IdProveedor, NuevaFila, habilitar, valuesPago, open = false, detallesNuevos = [] }) => {
  const toast = useRef(null)
  const op = useRef(null);
  const buttom = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const { userAuth } = useContext(AuthContext);
//   const [dataRow, setDataRow] = useState({})
  const { values, setValues, resetForm } = useForm({
    BalanceTotalL: 0,
    BalanceTotalD: 0,
    CantidadFacturas: 0
  });
  const [selectRetencion, setSelectRetencion] = useState([]);
  const [showDialogRetencion, setShowDialogRetencion] = useState(false);
  const [tempoRetenciones, setTempoRetenciones] = useState([]);

  const obtenerFacturas = async () => {
    setLoading(true)
    if (IdProveedor > 0) {
      // const result = await getCuentasProveedorPendientePorPagar(IdProveedor)
      const result = await getCuentasBalanceDisponibleProveedor(IdProveedor)
      let tempoResult = []
      if (result?.length > 0) {
        tempoResult = result.filter((r) => r.IdTipoDocumento !== 3)
        tempoResult?.forEach(r => {
          r.MontoD = r.DebitoD > 0 ? r.DebitoD : r.MontoD
          r.MontoL = r.DebitoL > 0 ? r.DebitoL : r.MontoL
        });

      }
      setData(tempoResult)
    }
    resetForm({})
    setSelected([])
    setLoading(false)
  }

  const openOver = (e) => {
    op.current.toggle(e)
    setLoading(true)
    obtenerFacturas()

  }

  useEffect(() => {
    if (open && detallesNuevos?.length > 0) {
      setSelected(detallesNuevos)
      AsignarInformacion(detallesNuevos)
    }
  }, [open])



  const AsignarInformacion = async (selected) => {


    let facturasRetenciones = selected?.filter((s) => s?.RetencionD > 0)
    if (facturasRetenciones.length > 0) {
      let IdsFacturas = [...new Set(facturasRetenciones.map(item => item?.IdIngreso))].join(", ")

      const tempoRetenciones = await getComprobantesRetencionByFacturas(IdsFacturas, IdProveedor)
      setTempoRetenciones(tempoRetenciones)
      setSelectRetencion(tempoRetenciones)
      if (tempoRetenciones?.length > 0) {
        let header = <div className="d-flex align-items-center">
          <i className="ri-message-3-line fs-2 me-2"></i>
          <h4 className="m-0">Retención</h4>
        </div>
        setShowDialogRetencion(true);
      } else {
        op.current.hide();
        NuevaFila(selected, valuesPago)
        setTimeout(() => {
          setSelected([])
        }, 100);
      }
    } else {
      op.current.hide();
      NuevaFila(selected, valuesPago)
      setTimeout(() => {
        setSelected([])
      }, 100);
    }

  }

  const DiasVencidos = (DiasVencidos) => {
    if (DiasVencidos < 0) {
      return (
        <span style={{ color: 'green', justifyContent: 'center', fontWeight: 'bold' }}
          className='text-overFlow text-alingth-center d-flex'>{DiasVencidos}</span>
      )
    } else {
      return (
        <span style={{ color: 'red', justifyContent: 'center', fontWeight: 'bold' }}
          className='text-overFlow text-alingth-center d-flex' >{DiasVencidos}</span>
      )
    }
  }

//   const openDocumento = (rowData) => {
//     let row = {
//       ...rowData,
//       IdReferenciaRegistro: rowData?.IdIngresoReferencia,
//       IdTipoInventario: rowData?.IdReferencia
//     }
//     switch (rowData?.IdTipoDocumento) {
//       case 1:
//         row.IdTipoReferencia = 7
//         break;
//       case 2:
//         row.IdTipoReferencia = 16
//         break;
//       default:
//         row.IdTipoReferencia = 7
//         break;
//     }
//     setDataRow(row)
//   }

  const table = {
    Data: data,
    selected: selected,
    setSelected: setSelected,
    Columns: [
      {
        field: 'IdIngreso',
        header: 'IdIngreso',
        headerEn: 'IdIngreso',
        className: 'Xsmall',
        hidden: userAuth.IdRol === 1
      },
      {
        field: 'FechaIngreso',
        header: 'FechaIngreso',
        headerEn: 'FechaIngreso',
        className: 'small',
        Format: 'Date',
        sort: 'asc',
        frozen: true,
        alignFrozen: 'left'
      },
      {
        field: 'NumeroIngreso',
        header: 'Numero Ingreso',
        headerEn: 'Numero Ingreso',
        className: 'small',
        Format: 'Center',
        Sumary: 'count',
        frozen: true,
        alignFrozen: 'left',
        // onCellDoubleClicked: ({ data }) => {
        //   if (data.IdIngreso > 0) {
        //     openDocumento(data)

        //   }
        // }
      },
      {
        field: 'Factura',
        header: 'Factura',
        headerEn: 'Factura',
        className: 'medium',
        frozen: true,
        alignFrozen: 'left'
      },
      {
        field: 'PO',
        header: 'PO',
        headerEn: 'PO',
        className: 'small',
        onCellDoubleClicked: ({ data }) => {
          if (data.PO) {
            window.open(`${process.env.REACT_APP_ENV}/OrdenesCompra/${data.PO}`, data.PO, 'height=800,width=1450')
          }
        }
      },
      {
        field: 'FechaFactura',
        header: 'Fecha Factura',
        headerEn: 'Fecha Factura',
        className: '',
        Format: 'Date',
      },
      {
        field: 'FechaVencido',
        header: 'Fecha Vencido',
        headerEn: 'Fecha Vencido',
        className: '',
        Format: 'Date',
      },
      {
        field: 'DiasVencidos',
        header: 'Dias Vencidos',
        headerEn: 'Dias Vencidos',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => DiasVencidos(rowData.DiasVencidos)
      },
      {
        field: 'UsuarioEdito',
        header: 'User Edit',
        headerEn: 'User Edit',
        className: 'small',
      },
      {
        field: 'UsuarioReviso',
        header: 'Usuario Reviso',
        headerEn: 'User Reviewed',
        className: 'small',
      },
      {
        field: 'PorcentajeDisponible',
        header: 'Porcentaje',
        headerEn: 'Percentage',
        className: 'Xsmall',
        Format: 'Porcentaje',
        alignFrozen: 'right',
        // Sumary: 'sum'
      },

      {
        field: 'MontoL',
        header: 'MontoL',
        headerEn: 'MontoL',
        className: 'small',
        Format: 'Currency',
        Sumary: 'sum'
      },
      // {
      //   field: 'BalanceL',
      //   header: 'BalanceL',
      //   headerEn: 'BalanceL',
      //   className: 'small',
      //   Format: 'Currency',
      //   Sumary: 'sum'

      // },
      {
        field: 'BalanceDisponibleL',
        header: 'BalanceL',
        headerEn: 'BalanceL',
        className: 'Xsmall',
        Format: 'Currency',
        Sumary: 'sum',
        Frozen: true,
        alignFrozen: 'right'
      },
      {
        field: 'MontoD',
        header: 'MontoD',
        headerEn: 'MontoD',
        className: 'Xsmall',
        Format: 'Currency',
        Sumary: 'sum'
      },
      // {
      //   field: 'BalanceD',
      //   header: 'BalanceD',
      //   headerEn: 'BalanceD',
      //   className: 'small',
      //   Format: 'Currency',
      //   Sumary: 'sum'
      // },
      {
        field: 'BalanceDisponibleD',
        header: 'BalanceD',
        headerEn: 'BalanceD',
        className: 'Xsmall',
        Format: 'Currency',
        Sumary: 'sum',
        Frozen: true,
        alignFrozen: 'right'
      },
      {
        field: 'IdRetencion',
        header: 'Retención',
        className: 'small',
        Format: 'Checkbox',
        disabled: true,
        onChange: (e, rowData) => { },
        Frozen: true,
        alignFrozen: 'right'
      },
    ]
  }
  const MostrarMontoTotal = () => {
    const BalanceTotalD = selected.reduce((t, v) => t + v.BalanceD, 0)
    const BalanceTotalL = selected.reduce((t, v) => t + v.BalanceL, 0)
    let tempoValues = { ...values }
    tempoValues.BalanceTotalL = BalanceTotalL
    tempoValues.BalanceTotalD = BalanceTotalD
    tempoValues.CantidadFacturas = selected?.length
    setValues(tempoValues)
  }

  useEffect(() => {
    if (selected.length > 0) {
      MostrarMontoTotal()
    }
  }, [selected])

  useEffect(() => {
    buttom.current = true
    obtenerFacturas()
  }, [buttom.current])

  return (
    <div>
      <div className='p-inputgroup ' >
        <Button label='Agregar Facturas' onClick={() => AsignarInformacion(selected)} disabled={selected.length === 0 ? true : false} style={{ height: 40 }} />
        <Button icon='pi pi-angle-down' type='button' onClick={(e) => openOver(e)} disabled={IdProveedor > 0 && habilitar ? false : true} style={{ height: 40 }} />
      </div>

      <OverlayPanel ref={op} showCloseIcon dismissable={false} style={{ width: '75vw', minHeight: '10vh' }}>
        <Loader loading={loading} querySelector='#OrdenesCliente' />
        <Toast ref={toast} />
        <div style={{ height: '35vh' }} id='OrdenesCliente'>
          <AgGrid table={table} />
        </div>
        <div className='d-flex flex-row' style={{ justifyContent: 'flex-end' }}>
          <span>
            <label style={{ fontWeight: 'bold', marginRight: 7 }}>Monto Total Lps:</label>
            <label>{formatNumberDecimal(values.BalanceTotalL)}</label>
          </span>

          <span className='mx-4'>
            <label style={{ fontWeight: 'bold', marginRight: 7 }}>Monto Total $:</label>
            <label>{formatNumberDecimal(values.BalanceTotalD)}</label>
          </span>

        </div>

      </OverlayPanel>

      {/* <RegistroContableDialogs
        dates={[]}
        dataRow={dataRow}
        setDataRow={setDataRow}
        getInfo={obtenerFacturas}
      /> */}
      <Dialog header='Retención' visible={showDialogRetencion} onHide={() => setShowDialogRetencion(false)} style={{ width: 650 }}>
        <div className='pt-4' >
          <h5>Existen retenciones de las facturas seleccionadas </h5>
          <div style={{ width: '100%', height: '50vh', overflow: 'auto' }} >
            {tempoRetenciones.map((r) => {
              return <div className='d-flex flex-row flex-center pt-3' style={{ alignItems: 'center' }} key={r.IdComprobanteRetencionDet} >
                <div className='d-flex mx-4' >
                  <Checkbox
                    checked={(selectRetencion.find(s => s.IdComprobanteRetencionDet === r.IdComprobanteRetencionDet) ? true : false)}
                    onChange={(value) => {
                      if (!value.checked) {
                        let tempoSelectRetencion = selectRetencion.filter((s) => s.IdComprobanteRetencionDet !== r.IdComprobanteRetencionDet)
                        setSelectRetencion(tempoSelectRetencion)
                      } else {
                        setSelectRetencion([...selectRetencion, r])
                      }
                    }} />

                </div>
                <div>
                  <div className='fw-bold'>Factura: {r.NoDocumento} </div>
                  <div className='fw-bold'>Cuenta: {r.CuentaFinanzas} </div>
                  <div className='d-flex gap'><span className='fw-bold'> No. Comprobante: </span> {r.NoComprobanteRetencion} -
                    <span className='fw-bold'> Fecha Comprobante:</span> {r.FechaEmision} </div>
                  <div className='d-flex gap'> <span className='fw-bold'> Porcentaje: </span>{r.TasaPorcentaje}% <span className='fw-bold'>  Base Retencion:</span> $ {formatNumberDecimal(r.MontoD)} -  L {formatNumberDecimal(r.MontoL)} </div>
                  <div className='d-flex gap'><span className='fw-bold'> Retencion: </span> $ {formatNumberDecimal(r.ImporteTotalD)} - L {formatNumberDecimal(r.ImporteTotalL)} </div>
                </div>
              </div>
            }
            )}

          </div>
          <h5 className='fw-bold pt-4'> ¿Desea aplicar la retención a la factura ? </h5>
          <div className='d-flex flex-end' >
            <Button label='Sí' severity='success' onClick={() => {

              let facturasRetenciones = selected?.filter((s) => s?.RetencionD > 0)

              let datosMovimiento = []
              let ingresoRetencion = []
              let retencionesAplicadas = []

              console.log(facturasRetenciones, tempoRetenciones);
              ingresoRetencion = facturasRetenciones.map((f) => {
                let retencionIngreso = selectRetencion.filter((r) => r.IdFactura === f.IdIngreso)
                console.log({ retencionIngreso });
                if (retencionIngreso.length > 0) {
                  let montoRetencionL = RedondearNumero(retencionIngreso?.reduce((t, v) => t + v.ImporteTotalL, 0))
                  let montoRetencionD = RedondearNumero(retencionIngreso?.reduce((t, v) => t + v.ImporteTotalD, 0))
                  let IdsRetenciones = [...new Set(retencionIngreso.map(item => item?.IdComprobanteRetencionEnc))].join(", ")

                  let balanceL = f.BalanceDisponibleL - montoRetencionL

                  if (balanceL >= 0) {
                    return {
                      ...f,
                      CreditoL: montoRetencionL,
                      CreditoD: montoRetencionD,
                      IdsRetencion: IdsRetenciones,
                      BalanceDisponibleL: f.BalanceDisponibleL - montoRetencionL,
                      BalanceDisponibleD: f.BalanceDisponibleD - montoRetencionD
                    }
                  }
                }
                setSelectRetencion([])
                setShowDialogRetencion(false);
                return null


              }).filter(Boolean);
              if (ingresoRetencion.length > 0) {
                let ingresosFinales = selected.filter((s) => !ingresoRetencion.some((i) => i.IdIngreso === s.IdIngreso))?.concat(ingresoRetencion)
                op.current.hide();
                NuevaFila(ingresosFinales, valuesPago)
                setTimeout(() => {
                  setSelectRetencion([])
                  setShowDialogRetencion(false);
                  setSelected([])
                }, 100);
              }
            }} className='mx-2' />
            <Button label='No' severity='danger' onClick={() => {
              op.current.hide();
              NuevaFila(selected, valuesPago)
              setTimeout(() => {
                setSelectRetencion([])
                setShowDialogRetencion(false);
                setSelected([])
              }, 100);
            }} className='mx-2' />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default OverlayFacturasPendientesPorPagar
